// Dependencies
import React, { Component, cloneElement, PropTypes } from 'react';
import reactUpdate from 'react-addons-update';
import debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import { equals } from 'ramda';

import LeftNav from './connections-left-nav/connections-left-nav';

import {
        filterConnections,
        filterConnectionsByCountry,
        getCountries,
        removeConnection,
        ignoreConnection,
        acceptConnection,
        undoConnectionChange,
        resendConnection } from '../../stores/connections/connections-actions';
import { refreshConnectionsStats } from '../../stores/connections-stats/connections-stats-actions';


class ConnectionsContainer extends Component {

  constructor(props) {
    super(props);

    document.getElementsByTagName('body')[0].scrollTop = 0;

    this.state = {
      filter: true,
      filteredTagsMap: {},
      filteredCountries: [],
      routeName: this.getRouteName(),
    };
  }
  componentWillMount() {
    const { routes } = this.props;
    const route = routes[2];
    this.filterResults(route ? route.path.slice(13) : 'connected');
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getCountries());
  }

  componentWillReceiveProps(nextProps) {
    const routeName = this.getRouteName(nextProps);
    if (this.state.routeName !== routeName) {
      this.setState({ routeName });
    }
    if (!equals(nextProps.urlQuery, this.props.urlQuery)) {
      this.filterResults(routeName, nextProps);
    }
  }

  getRouteName = (props) => {
    const { history } = props || this.props;
    if (history.isActive('/connections/invitations')) return 'invites';
    if (history.isActive('/connections/requests')) return 'requests';
    return 'connected';
  };
  filterResults = (routeName, props) => {
    const { dispatch, urlQuery: { id: connectionId } = {} } = props || this.props;
    const payload = {
      status: routeName === 'invitations' ? 'invites' : routeName,
      q: this.state.input,
      tags: Object.keys(this.state.filteredTagsMap),
      countries: this.state.filteredCountries,
      connectionId,
    };
    dispatch(filterConnections(payload));
    dispatch(refreshConnectionsStats());
  };

  filterByCountry = filteredCountries => {
    const { dispatch } = this.props;
    const { routeName, input, filteredTagsMap } = this.state;
    const tags = Object.keys(filteredTagsMap);
    this.setState({ filter: !filteredCountries.length, filteredCountries }, () => dispatch(filterConnectionsByCountry({
      'status': (() => {
        if (this.state.filter) {
          if (routeName === 'invitations') return 'invites';
          return routeName;
        }
        return 'all';
      })(),
      'q': input,
      tags,
      'countries': filteredCountries,
    })));
  };

  removeCountryFilter = countryName => {
    const { filteredCountries } = this.state;
    this.filterByCountry(filteredCountries.filter(country => country !== countryName));
  };


  addOrRemoveTag = (tag, remove) => {
    const { dispatch } = this.props;
    if (!this.state.filteredTagsMap[tag] || remove) {
      const newState = reactUpdate(this.state, {
        filteredTagsMap: {
          $apply: tagsMap => {
            if (remove) delete tagsMap[tag];
            else tagsMap[tag] = tag;
            return tagsMap;
          },
        },
      });
      this.setState(newState, () => {
        const { filteredTagsMap, filteredCountries, routeName, input } = this.state;
        const tags = Object.keys(filteredTagsMap);
        const payload = {
          'status': (() => {
            if (!tags.length) {
              if (routeName === 'invitations') return 'invites';
              return routeName;
            }
            return 'all';
          })(),
          'q': input,
          tags,
          'countries': filteredCountries,
        };
        dispatch(filterConnections(payload));
      });
    }
  };

  loadMoreConnections = (pageNo) => {
    // 'filter': true,
    const { dispatch, connections } = this.props;
    const { input, routeName, filter, filteredTagsMap, filteredCountries } = this.state;
    if (connections.page === pageNo) return;
    dispatch(filterConnections({
      'status': (() => {
        if (filter) {
          if (routeName === 'invitations') return 'invites';
          return routeName;
        }
        return 'all';
      })(),
      'q': input,
      'tags': Object.keys(filteredTagsMap),
      'countries': filteredCountries,
      'page': pageNo,
    }, true));
  };

  dispatchSearch = debounce(input => {
    const { dispatch } = this.props;
    const { routeName, filteredTagsMap, filteredCountries } = this.state;
    const payload = {
      'status': this.state.input ? 'all' : routeName,
      'q': input,
      'tags': Object.keys(filteredTagsMap),
      'countries': filteredCountries,
    };
    dispatch(filterConnections(payload));
  }, 400);

  search = input => {
    this.setState({ filter: false, input },
      this.dispatchSearch.call(this, input));
  };

  sendRouteName = routeName => {
    document.getElementById('connectionsSearch').innerHTML = '';
    this.setState({ filter: true, routeName },
      this.filterResults.call(this, routeName));
  };

  resendConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(resendConnection(connectionId))
    .catch(() => {
      triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
      dispatch(undoConnectionChange());
    });
  };

  acceptConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(acceptConnection(connectionId))
    .catch(() => {
      triggerSnackBarMessage({ message: 'Accepting Connection Failed' });
      dispatch(undoConnectionChange());
    });
  };

  removeConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(removeConnection(connectionId))
    .then(() => triggerSnackBarMessage({
      message: 'Connection Removed',
      // actionText: 'Undo',
      // actionTap: () => dispatch(undoConnectionChange(true)),
    }))
    .catch(() => {
      triggerSnackBarMessage({ message: 'Removing Connection Failed' });
      dispatch(undoConnectionChange());
    });
  };

  ignoreConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(ignoreConnection(connectionId))
    .catch(() => {
      triggerSnackBarMessage({ message: 'Ignoring Connection Failed' });
      dispatch(undoConnectionChange());
    });
  };

  render() {
    const { filteredTagsMap, filteredCountries, input } = this.state;
    const { children, dispatch, ...props } = this.props;
    const filterOptions = filteredCountries.map((country) => {
      return {
        name: country,
        action: () => this.removeCountryFilter(country),
      };
    }).concat(Object.keys(filteredTagsMap).map((key) => {
      return {
        name: filteredTagsMap[key],
        action: this.addOrRemoveTag,
      };
    }));

    const searchInput = (filterOptions.length || input) ? true : undefined;

    const extraProps = {
      filterResults: this.filterResults,
      filterByCountry: this.filterByCountry,
      addOrRemoveTag: this.addOrRemoveTag,
      loadMoreConnections: this.loadMoreConnections,
      search: this.search,
      sendRouteName: this.sendRouteName,
      resendConnection: this.resendConnection,
      acceptConnection: this.acceptConnection,
      removeConnection: this.removeConnection,
      ignoreConnection: this.ignoreConnection,
      searchInput,
      filterOptions,
      ...props,
      ...this.state,
    };
    const { connectionsStats } = this.props;

    const connectionsOrSplash = (() => {
      if (connectionsStats.isSynced) {
        if (children) {
          return (
            <div className="l-app-content l-left-nav-with-content">
              <LeftNav className="connections-left-nav l-left-nav" {...extraProps} />
              {cloneElement(children, extraProps)}
            </div>);
        }
      }
    })();
    return (
      <div >
        {connectionsOrSplash}
      </div>
    );
  }
}

function select(state) {
  const {
    routing: {
      locationBeforeTransitions: { query: urlQuery = {} },
    },
  } = state;
  return {
    connectionsStats: state.connectionsStats.toJS(),
    connections: state.connections.toJS(),
    urlQuery,
    tags: state.tags.toJS(),
    user: state.user.toJS(),
  };
}

ConnectionsContainer.propTypes = {
  history: PropTypes.object,
  routes: PropTypes.array,
  dispatch: PropTypes.func,
  connectionsStats: PropTypes.object,
  connections: PropTypes.object,
  triggerSnackBarMessage: PropTypes.func,
  children: PropTypes.object,
  user: PropTypes.object,
  urlQuery: PropTypes.object,
};

export default connect(select)(ConnectionsContainer);



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-container.jsx